import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext();

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    site_title: "",
    footer_text: "",
    logo_base64: null,
    favicon_base64: null
  });

  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      console.error("Failed to load settings:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  // Apply settings to DOM when they change
  useEffect(() => {
    if (!loading && settings.site_title) {
      document.title = settings.site_title;
    }
    
    if (!loading && settings.favicon_base64) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = settings.favicon_base64;
    }
  }, [settings, loading]);

  const updateSettings = async (updates) => {
    await api.post("/settings", updates);
    await fetchSettings();
  };

  return (
    <SettingsContext.Provider value={{ settings, updateSettings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
